<template>
<div v-bar id="imagecontainer"> 
    <div id="images">
      <div id="padding">
    <img :key="image.id" v-for="image in project.project_images" :src= "vps_path + image.url">
    </div>
    </div>
</div>  
</template>

<script>
import '../../src/assets/css/leonie_scrollbar.css';

export default {
    name: 'ProjectImages',
    props: ["project", "vps_path"],
    data() {
		return {
        }
    },
}
</script>

<style scoped>

#top {
  box-shadow: inset -1px 5px 12px -4px lightgrey; 
  position:fixed;
  height:15px;
  width:33%;
  z-index:10;
  visibility: hidden;
}

#bottom {
  box-shadow: inset -1px -5px 12px -4px lightgrey; 
  bottom:10px;
  position:fixed;
  height:15px;
  width:33%;
  z-index:10;
  visibility: hidden;
}

#imagecontainer {
  border-radius:25px;
  overflow: hidden;
  position:absolute;
	width: 100%;
  height:100%;
  /* background-color:black; */
}

#images {
  width: 100%;
  height:100%;
}

#padding {
  padding-top:3.5vh;
  padding-bottom:3.5vh;
}

img {
  /* position:relative; */
  display:inline-block;
  margin-left:2.6vw;
	width:27.6vw;
  height:auto;
  margin-top:10px;
  margin-bottom:10px;
}

</style>